import { ComponentRef, Directive, Input, OnChanges, OnInit, Type, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormInputComponent } from '../form-input/form-input.component';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/common-models';
import { FormCheckboxComponent } from '../form-checkbox/form-checkbox.component';
import { FormTextareaComponent } from '../form-textarea/form-textarea.component';
import { FormSelectComponent } from '../form-select/form-select.component';
import { FormdateComponent } from '../form-date/form-date.component';
import { FormRadioComponent } from '../form-radio/form-radio.component';
import { FormInputSelectComponent } from '../form-input-select/form-input-select.component';
import { FormAutocompleteComponent } from '../form-autocomplete/form-autocomplete.component'
import { FormAddButtonComponent } from '../form-add-button/form-add-button.component';
import { FormTimeComponent } from '../form-time/form-time.component';
// Swire Change
import { FormChipComponent } from '../form-chip/form-chip.component';
// Swire Change



const components: {[type: string]: Type<Field>} = { 
  input: FormInputComponent,  
  checkbox: FormCheckboxComponent,
  textarea: FormTextareaComponent,
  select: FormSelectComponent,
  date: FormdateComponent,
  radio: FormRadioComponent,
  inputSelect: FormInputSelectComponent,
  autocomplete: FormAutocompleteComponent,
  addBtn: FormAddButtonComponent,
  time: FormTimeComponent,
  // Swire Change
  chip: FormChipComponent
  // Swire Change
};

@Directive({
    selector: '[dynamicField]',
    standalone: false
})
export class DynamicFieldDirective implements Field, OnChanges, OnInit {
  @Input()
  config: FieldConfig;

  @Input()
  group: UntypedFormGroup;

  component: ComponentRef<Field>;

  constructor(
    private container: ViewContainerRef
  ) {
  }

  ngOnChanges() {
    if (this.component) {
      this.component.instance.config = this.config;
      this.component.instance.group = this.group;
    }
  }

  ngOnInit() {
    if (!components[this.config.type]) {
      const supportedTypes = Object.keys(components).join(', ');
      throw new Error(
        `Trying to use an unsupported type (${this.config.type}).
        Supported types: ${supportedTypes}`
      );
    }
    this.component = this.container.createComponent(components[this.config.type]);
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
  }
}
